import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import bg from '../../images/offer-bg.webp'
import infra from "../../images/infra.jpg"
import { useMediaQuery } from 'react-responsive';


const Offer = () => {
    const isMobile = useMediaQuery({ query: '(max-width: 991px)' });
    return (
        <div className='offer-section section-padding position-relative'
        //  style={{ backgroundImage: `url(${infra})` }}
         >
            <Container>
            <h1 className={`text-capitalize offercontentmain ${isMobile ? 'mb-2': 'mb-4'}`}>Our Services</h1>
                <Row>
                {
                         isMobile &&
                         <Col lg={6}>
                         <img className='infrsimage' src={infra}></img>
                         </Col>
                    }
                    <Col lg={6}>
                        <div className='position-relative offercontent'>
                            <h2 className={`text-capitalize ${isMobile ? 'mb-2': 'mb-4'}`}>Infrastructure Contracts</h2>
                            <h6 className='text-capitalize'>We specialize in executing large-scale infrastructure projects with precision and reliability. Whether it’s road construction, industrial development, or complex civil engineering works, our team is equipped to deliver on time and within budget.</h6>
                          
                        </div>
                    </Col>
                    {
                         !isMobile &&
                         <Col lg={6}>
                         <img className='infrsimage' src={infra}></img>
                         </Col>
                    }
                </Row>
            </Container>
        </div>
    )
}

export default Offer
